import React, { Component } from "react"
import SbEditable from "storyblok-react"
import ImagesService from '../../../utils/images-service'
import Button from "../../Button"

import "./styles.scss"


class Newslist extends Component {
    constructor(props) {
        super(props)
        this.blok = props.blok

        this.news = this.blok.news.sort((a, b) => {
            const dateA = new Date(a.first_published_at).getTime()
            const dateB = new Date(b.first_published_at).getTime()
            console.log(dateA, dateB);
            if (dateA < dateB) {
                return 1
            }
            if (dateA > dateB) {
                return -1
            }
            return 0
        })
    }

    render() {
        return (
            <div className="newslist">
                <div className="container">
                <SbEditable content={this.blok}>
                    <div className="list">
                        {this.news.map((entry, index) =>
                        <a key={index} href={`/${entry.full_slug}`} className="news-item">
                            <picture>
                                <source media="(max-width: 450px)" srcSet={`${ ImagesService(entry.content.image.filename, true, { path: '450x450/smart/filters:format(webp)'}) } 1x, ${ ImagesService(entry.content.image.filename, true, { path: '900x900/smart/filters:format(webp)'}) } 2x`} type="image/webp" />
                                <source media="(max-width: 450px)" srcSet={`${ ImagesService(entry.content.image.filename, true, { path: '450x450/smart/filters:format(jpeg):quality(60)'}) } 1x, ${ ImagesService(entry.content.image.filename, true, { path: '900x900/smart/filters:format(jpeg)'}) } 2x`} type="image/jpeg" />
                                <source srcSet={`${ ImagesService(entry.content.image.filename, true, { path: '300x300/smart/filters:format(webp)'}) } 1x, ${ ImagesService(entry.content.image.filename, true, { path: '600x600/smart/filters:format(webp)'}) } 2x`} type="image/webp" />
                                <source srcSet={`${ ImagesService(entry.content.image.filename, true, { path: '300x300/smart/filters:format(jpeg):quality(60)'}) } 1x, ${ ImagesService(entry.content.image.filename, true, { path: '600x600/smart/filters:format(jpeg):quality(60)'}) } 2x`} type="image/jpeg" />
                                <img loading="lazy" src={ImagesService(entry.content.image.filename, true, { path: '300x300/smart/filters:format(jpeg):quality(60)'})} alt={entry.name} width="300" height="300" />
                            </picture>
                            <div className="overlay">
                                <h2>{entry.name}</h2>
                                <div className="read-article"><span>Beitrag lesen</span><i className="material-icons">keyboard_arrow_right</i></div>
                            </div>
                        </a>
                        )}
                    </div>
                    {this.blok.newsarchiveLink.url !== "" &&
                    <div className="more-news">
                        <Button type="tertiary" to={this.blok.newsarchiveLink.url} label="Weitere Beiträge lesen" />
                    </div>
                    }
                </SbEditable>
            </div>
            </div>
        )
    }
}  
  
export default Newslist